export default __webpack_public_path__ + "static/media/Santorini.f3ebbc0a.mp4";